<script setup lang="ts">
import { creditSimulatorChoiceVariants } from '.';

defineProps<{
	legend: string;
	options: string[];
	selected: string | null;
}>();

const emit = defineEmits<{ pick: [option: string] }>();
</script>

<template>
	<fieldset class="m-0 border-none p-0">
		<legend class="mb-3 p-0 text-[15px] font-medium">{{ legend }}</legend>
		<div class="flex flex-wrap gap-2">
			<button
				v-for="option in options"
				:key="option"
				type="button"
				:aria-pressed="selected === option"
				:class="
					creditSimulatorChoiceVariants({
						kind: 'option',
						selected: selected === option
					})
				"
				@click="emit('pick', option)"
			>
				{{ option }}
			</button>
		</div>
	</fieldset>
</template>
